import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

export default function Container({ style, children, onClose }) {
  return (
    <div
      className="container"
      style={style}
    >
      <button className="btn-close" onClick={onClose}>
        <i className="material-icons">close</i>
      </button>
      {children}
    </div>
  );
}

Container.propTypes = {
  style: PropTypes.shape(),
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
};

Container.defaultProps = {
  style: {},
};
